<script setup lang="ts">
import { PlusCircleIcon } from "@heroicons/vue/24/outline";

const modelValue = defineModel<{
  hotel_name: string;
  address: string;
}>();

const isOpen = ref(false);

function closeModal() {
   isOpen.value = false;
}
function openModal() {
   isOpen.value = true;
}

const isModelValueFilled = computed(() => {
   // @ts-ignore @wolfcoder FIXME: TS issue
   return modelValue.value?.hotel_name?.length > 0 && modelValue.value?.address?.length > 0;
});
</script>

<template>
   <button
      @click="openModal"
      class="px-3 py-2 mb-4 mr-3 text-sm bg-white rounded-md cursor-pointer ring-1 ring-inset hover:bg-gray-50"
      :class="
         isModelValueFilled
            ? 'text-green-600 ring-green-600'
            : 'text-primary ring-primary'
      "
   >
      <div
         v-if="!isModelValueFilled"
         class="flex items-center justify-between space-x-1"
      >
         <PlusCircleIcon class="w-6 h-6" aria-hidden="true" />
         <span> Enter participant details </span>
      </div>
      <div v-else>Booking Info Complete</div>
   </button>

   <HeadlessTransitionRoot as="template" :show="isOpen">
      <HeadlessDialog class="relative z-10" @close="closeModal">
         <HeadlessTransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0"
         >
            <div
               class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
            />
         </HeadlessTransitionChild>

         <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div
               class="flex items-center justify-center min-h-full p-4 text-center sm:items-center sm:p-0"
            >
               <HeadlessTransitionChild
                  as="template"
                  enter="ease-out duration-300"
                  enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enter-to="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leave-from="opacity-100 translate-y-0 sm:scale-100"
                  leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
               >
                  <HeadlessDialogPanel
                     class="relative min-w-[20rem] transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
                  >
                     <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                        <div class="sm:flex sm:items-start">
                           <div class="mt-3 sm:ml-4 sm:mt-0 sm:text-left">
                              <HeadlessDialogTitle
                                 as="h3"
                                 class="text-base font-semibold leading-6 text-gray-900"
                              >
                                 Pickup Info
                              </HeadlessDialogTitle>
                           </div>
                           <div class="pt-4 mt-2">
                              <label> Hotel name </label>
                              <input
                              v-model="modelValue.hotel_name"
                              class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                              /> 
                              <label> Address </label>
                              <input
                              v-model="modelValue.address"
                              class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                              /> 
                           </div>
                        </div>
                     </div>
                     <div
                        class="px-4 py-3 bg-gray-50 sm:flex sm:flex-row-reverse sm:px-6"
                     >
                        <button
                           @click="closeModal"
                           type="button"
                           class="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm hover:primary-hover bg-primary sm:ml-3 sm:w-auto"
                        >
                           Save
                        </button>
                     </div>
                  </HeadlessDialogPanel>
               </HeadlessTransitionChild>
            </div>
         </div>
      </HeadlessDialog>
   </HeadlessTransitionRoot>
</template>
